import { startCase, uniqBy } from 'lodash'

import { getPickupForConcessions } from 'utils/revenueCenters'

export const getMenus = (state) =>
  Object.values(state.menus?.byId ?? {})

export const getMenu = (state, uuid) => state?.menus?.byId?.[uuid]

export const getIsMenusLoading = (state) =>
  state?.menus?.isLoading ?? false

export const getAllServiceTypesNames = (state) => {
  const allMenus = getMenus(state)

  const allServieTypes = allMenus.map((menu) => ({
    name: startCase(menu.serviceType),
    uuid: menu.serviceType,
  }))

  const uniqServiceTypes = uniqBy(allServieTypes, 'name')

  // remove empty service types
  const nonEmptyServiceTypes = uniqServiceTypes.filter(
    (serviceType) => serviceType.name !== ''
  )

  //Concessions is not suported name, that's why it's changed to Pickup
  const transformedUniqServiceTypesNames = nonEmptyServiceTypes.map(
    (serviceType) => {
      return {
        name: getPickupForConcessions(serviceType.name),
        uuid: serviceType.uuid,
      }
    }
  )

  return transformedUniqServiceTypesNames
}
